import { MultiPropertyProvider } from "../../core/prop";
import { ListenableEvent } from "../../utils";
import { ItemUpdateFlags } from "../BaseItem";
import { ArticlePropertyProvider } from "./ArticlePropertyProvider";
export class MultiArticlePropertyProvider extends MultiPropertyProvider {
    //// internal //////////////////////////////////////////////////////////////////////////////
    /** @internal */
    static _Create(pBasket, pArticles) {
        const tProvider = new MultiArticlePropertyProvider(pBasket);
        tProvider.setProviders(pArticles.map((pArticle) => new ArticlePropertyProvider(pBasket, tProvider, pArticle)));
        return (tProvider);
    }
    /** @internal */
    _notifyMainArticleChanged(pArticle, pUpdateParent) {
        if (this.mChangedParents != null && pUpdateParent)
            this.mChangedParents.add(pArticle.parent == null ? this.mBasket.root : pArticle.parent);
        if (this.mChangedMainArticles != null)
            this.mChangedMainArticles.add(pArticle);
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    beginSetPropertyValue() {
        this.mChangedParents = new Set();
        this.mChangedMainArticles = new Set();
        super.beginSetPropertyValue();
    }
    endSetPropertyValue() {
        this.mChangedParents = null;
        this.mChangedMainArticles = null;
        super.endSetPropertyValue();
    }
    async finalizeSetPropertyValue() {
        if (this.mChangedMainArticles == null || this.mChangedMainArticles.size === 0)
            return;
        try {
            this.mBasket._beginItemUpdate();
            this.mBasket._beginCaching();
            //fetch main articles
            const tMainArticles = Array.from(this.mChangedMainArticles);
            await this.mBasket._fetchEaiwsItems(tMainArticles.map((pArticle) => pArticle.id), false, true);
            //update parent items (maybe items where added or removed)
            if (this.mChangedParents != null && this.mChangedParents.size > 0) {
                const tParentItems = Array.from(this.mChangedParents);
                //cache all parent items first and update them
                await this.mBasket._fetchEaiwsItems(tParentItems.map((pItem) => pItem.id), false, false);
                for (const tItem of tParentItems) {
                    await tItem.updateItem(ItemUpdateFlags.Item);
                    tItem.invalidateGroupCalculations();
                }
            }
            //update changed main articles
            for (const tArticle of tMainArticles) {
                await tArticle.updateWholeComposite(ItemUpdateFlags.All & ~ItemUpdateFlags.UserFields);
            }
        }
        finally {
            this.mBasket._endCaching();
            this.mBasket._endItemUpdate();
        }
    }
    constructor(pBasket) {
        super(null);
        this.eventSetPropValueError = new ListenableEvent(this);
        this.mBasket = pBasket;
        this.mChangedParents = null;
        this.mChangedMainArticles = null;
    }
}
